<template>
  <first-page>
    <div class="m-login__forget-password flipInX animated">
      <div id="create_password">
        <div class="m-login__head">
          <h3 class="m-login__title">Ustaw hasło</h3>
          <div class="m-login__desc"></div>
        </div>

        <b-alert :show="errorMessage.length"
                 variant="danger">
          {{errorMessage}}
        </b-alert>

        <div class="m-login__form m-form mt-4">
          <div class="form-group m-form__group">
            <password-input v-model="password"
                            m-input
                            placeholder="Hasło"
                            @valid="passwordState = true"
                            @invalid="passwordState = false"></password-input>
          </div>

          <div class="form-group m-form__group">
            <b-form-input id="repeat-password"
                          class="m-input"
                          :state="repeatPasswordState"
                          type="password"
                          placeholder="Powtórz hasło"
                          aria-describedby="repeatPasswordFeedback"
                          v-model="repeatPassword"></b-form-input>
            <b-form-invalid-feedback id="repeatPasswordFeedback">
              Podane hasła nie są identyczne
            </b-form-invalid-feedback>
          </div>
          <div class="m-login__form-action">
            <button id="m_login_set_password_submit"
                    class="btn m-btn m-btn--pill m-btn--custom m-btn--air btn-ls" :disabled="disableSendButton"
                    @click="createPassword">Wyślij
            </button>
            <button id="m_login_set_password_cancel"
                    class="btn m-btn m-btn--pill m-btn--custom btn-outline-ls m-btn--hover-ls"
                    @click="logout">Anuluj
            </button>
          </div>
        </div>
      </div>
    </div>
  </first-page>
</template>

<script>
  import FirstPage from "../pages/FirstPage";
  import {mapActions, mapState} from 'vuex'
  import PasswordInput from "../input/PasswordInput";

  export default {
    name: "CreatePassword",
    components: {PasswordInput, FirstPage},
    data() {
      let token = '';

      if (this.$route.params.hasOwnProperty('token')) {
        token = this.$route.params.token
      }

      return {
        token,
        email: '',
        entity: '',
        password: '',
        repeatPassword: '',
        errorMessage: '',
        passwordState: false
      }
    },
    beforeCreate() {
      this.$store.dispatch('logout', {pushToLogin: false})
    },
    mounted() {
      this.checkToken()
    },
    methods: {
      ...mapActions([
        'logout',
        'login',
        'fetchSettings'
      ]),
      checkToken() {
        this.$http.get(`password/create/${this.token}`)
          .then((r) => {
            if (r.data.success) {
              this.email = r.data.email;
              this.entity = r.data.entity;
              this.fetchSettings(r.data.entity);
            } else {
              this.logout();
            }
          })
      },
      createPassword() {
        this.$http.patch(`password/create/${this.token}`, {
          password: this.password,
          repeatPassword: this.repeatPassword
        })
          .then((r) => {
            if (r.data.success) {
              this.login({
                login: this.email,
                password: this.password,
                entity: this.entity
              })
            } else {
              this.errorMessage = r.data.message
            }
          })
      }
    },
    computed: {
      ...mapState({}),
      repeatPasswordState() {
        if (!this.repeatPassword.length) {
          return null
        }

        return this.password === this.repeatPassword;
      },
      disableSendButton() {
        return !(this.passwordState && this.repeatPasswordState)
      }
    }
  }
</script>

<style>
  .m-login__form {
    min-width: 250px;
  }

  .m-login__form-action > button:first-child {
    margin-right: 5px;
  }

  .form-control.is-invalid:focus {
    box-shadow: 0 .2rem .2rem -.2rem red !important;
  }

  .form-control.is-valid:focus {
    box-shadow: 0 .2rem .2rem -.2rem green !important;
  }
</style>
